import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import path from 'ramda/es/path';
import { useTranslation } from 'react-i18next';

import Loading from 'app/components/Loader';

import { IconIn, IconOut/* , IconWarn */ } from '../../../_Icons';
import selectPasses from './selectPasses';
import styles from './PassagesList.scss';
import tableStyles from '../table.scss';


const icons = {
  in: <IconIn className={tableStyles.in} />,
  out: <IconOut className={tableStyles.out} />,
};

const PassagesList = (props) => {
  const { t } = useTranslation('passes');

  const passages = useSelector(state => selectPasses(state, { ...props, t }));
  const isPeriod = !!path(['params', 'date2'], props);
  const loading = useSelector(state => state.passages.opts.loading, shallowEqual);
  const nothing = !useSelector(state => state.passages.data.count, shallowEqual);

  if (loading) {
    return <Loading />;
  }

  return (
    <table className={tableStyles.table}>
      <tbody>
        {nothing
          ? <tr><td colSpan={isPeriod ? 5 : 4} className={styles.nodata}>{t('empty')}</td></tr>
          : passages.map(({ id, action, actionText, place, comment, date, time }) =>
            <tr key={id}>
              {isPeriod && <td className={tableStyles.tDate}>{date}</td>}
              <td className={tableStyles.tPlace}>{place}</td>
              <td className={tableStyles.tAct}>
                {icons[action]}
                <span className={tableStyles.vert}>{actionText}</span>
              </td>
              <td className={tableStyles.tTime}>{time}</td>
              <td className={tableStyles.tComment}>
                <div>{comment}</div>
                {/* Отключены восклицательные знаки */}
                {/* {comment && <IconWarn />} */}
              </td>
            </tr>)}
      </tbody>
    </table>
  );
};

export default PassagesList;
